import { render, staticRenderFns } from "./TaxClassificationIpiForm.vue?vue&type=template&id=3b82b590&"
import script from "./TaxClassificationIpiForm.vue?vue&type=script&lang=js&"
export * from "./TaxClassificationIpiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b82b590')) {
      api.createRecord('3b82b590', component.options)
    } else {
      api.reload('3b82b590', component.options)
    }
    module.hot.accept("./TaxClassificationIpiForm.vue?vue&type=template&id=3b82b590&", function () {
      api.rerender('3b82b590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/TaxClassificationIpiForm.vue"
export default component.exports